// src/components/modals/ForwardModal.jsx
import React, { useState } from 'react';
import Modal from '../common/Modal';
import ChatAvatar from '../ChatAvatar';
// import { API_URL } from '../../utils/constants';
import { formatFileSize } from '../../utils/formatters';
import './ForwardModal.css';

const ForwardModal = ({
    isOpen,
    onClose,
    forwardMessage,
    chats,
    currentChat,   
    onSend,                      // (recipients, comment) => Promise
}) => {
    const [recipients, setRecipients] = useState([]);
    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false);

    // Сброс при открытии
    React.useEffect(() => {
        if (isOpen) {
            setRecipients([]);
            setComment('');
        }
    }, [isOpen]);

    const toggleRecipient = (chat) => {
        if (recipients.some(r => r.chat_id === chat.chat_id)) {
            setRecipients(recipients.filter(r => r.chat_id !== chat.chat_id));
        } else {
            setRecipients([...recipients, chat]);
        }
    };

    const handleSend = async () => {
        if (recipients.length === 0) {
            alert('Выберите хотя бы один чат');
            return;
        }

        setLoading(true);
        try {
            await onSend(recipients, comment);
            onClose();
        } catch (error) {
            console.error('Failed to forward:', error);
        } finally {
            setLoading(false);
        }
    };

    if (!forwardMessage) return null;

    // Чаты без текущего
    const availableChats = chats.filter(c => c.chat_id !== currentChat?.chat_id);

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Переслать сообщение"
            icon="bi bi-share"
            size="medium"
            footer={
                <>
                    <button className="btn-cancel" onClick={onClose}>Отмена</button>
                    <button 
                        className="btn-forward" 
                        onClick={handleSend}
                        disabled={recipients.length === 0 || loading}
                    >
                        <i className="bi bi-send-fill"></i>
                        {loading ? 'Отправка...' : `Переслать (${recipients.length})`}
                    </button>
                </>
            }
        >          

            {/* Список чатов */}
            <div className="forward-chats-list">
                <div className="chats-label">Выберите получателей:</div>
                <div className="chats-list-forward">
                    {availableChats.map(chat => (
                        <div
                            key={chat.chat_id}
                            className={`forward-chat-item ${recipients.some(r => r.chat_id === chat.chat_id) ? 'selected' : ''}`}
                            onClick={() => toggleRecipient(chat)}
                        >
                            <ChatAvatar
                                chat={chat}                                
                                className="chat-avatar-small"
                                imgClassName=""
                                placeholderClassName="avatar-placeholder-small"
                            />
                            <div className="chat-info">
                                <div className="chat-title">{chat.title}</div>
                                <div className="chat-type">{chat.type === 'group' ? 'Группа' : 'Приватный чат'}</div>
                            </div>
                            <div className="chat-checkbox">
                                <i className={recipients.some(r => r.chat_id === chat.chat_id) ? 'bi-check-circle-fill' : 'bi-circle'}></i>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Оригинальное сообщение */}
            <div className="forward-original-message">
                <div className="original-header">
                    <i className="bi bi-reply-fill"></i>
                    <span>Оригинальное сообщение</span>
                </div>
                <div className="original-author">
                    От: {forwardMessage.display_name || forwardMessage.from_username}
                </div>

                {forwardMessage.content && forwardMessage.content.trim() !== '' && forwardMessage.type !== 'sticker' && (
                    <div className="original-content-text">
                        {forwardMessage.content}
                    </div>
                )}

                {forwardMessage.type === 'sticker' && (
                    <div className="original-content-text">🎨 Стикер</div>
                )}

                {forwardMessage.attachments && forwardMessage.attachments.length > 0 && (
                    <div className="original-attachments">
                        {forwardMessage.attachments.map((att, idx) => (
                            <div key={idx} className="original-attachment">
                                <i className="bi bi-file-earmark"></i> {att.file_name}
                                {att.file_size && ` • ${formatFileSize(att.file_size)}`}
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Комментарий */}
            <div className="forward-comment">
                <textarea 
                    name="forward-comment"
                    placeholder="Добавить комментарий..."
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    rows="2"
                />
            </div>
        </Modal>
    );
};

export default ForwardModal;